import React from 'react';
import ServiceListItem from '../ServiceListItem';
import JsxHelper from '../../Helpers/JsxHelper';
import LookupText from '../../Elements/LookupText';
import LookupTextLookupItemIdArray from '../../Elements/LookupTextLookupItemIdArray';

export default class EmployeeSurveyServiceItem extends ServiceListItem {
  static FieldsToShowInListTable = [
    ...ServiceListItem.generalTab,
    {
      tabName: 'ProgramApproach',
      tabLabel: 'Program Approach',
      icon: 'fa-solid fa-diagram-project',
      data: [
        { name: 'Objective', label: 'Objective' },
        { name: 'Frequency', label: 'Frequency' },
        { name: 'TargetAudience', label: 'Target Audience (Location, Gender, Age, Profession, Income, Other)' },
        { name: 'TargetNumResponses', label: 'Target Number of Responses?' },
        { name: (item) => Array.isArray(item.DistributionOfSurvey) ? item.DistributionOfSurvey.join(', ') : (item.DistributionOfSurvey || ''), label: 'Distribution of Survey' },
        { name: (item) => JsxHelper.YesNo(item.BareOrClientSend), label: 'Does BARE Send or Does the Client Send?' },
        { name: 'SmsorEmailForBare', label: 'If BARE Sends, SMS or Email?' },
        { name: 'FrequencyOfSurvey', label: 'Frequency of Survey?' },
        { name: 'DurationOfSurvey', label: 'Duration of Survey' },
        { name: 'PreferredTimeline', label: 'Preferred Timeline of Starting and Receiving the Results' },
        { name: 'BareBrandedOrCompanyBranded', label: 'Bare Branded or Company Branded?' },
        { name: (item) => JsxHelper.YesNo(item.EmployeesEnterName), label: 'Do Employees Enter Their Name?' },
        { name: 'IncentivesDescription', label: 'Incentives (please describe)?' },
      ],
    },
    {
      tabName: 'Survey',
      tabLabel: 'Survey',
      icon: 'fa-solid fa-clipboard-question',
      data: [
        { name: 'NumClosedQuestions', label: 'No. Closed Questions' },
        { name: 'NumOpenQuestions', label: 'No. Simple Text Questions' },
        { name: 'NumNarrativeQuestions', label: 'No. Narrative Questions' },
        { name: (item) => JsxHelper.YesNo(item.QuestionnaireProvided), label: 'Questionnaire Provided by Client?' },
        { name: (item) => JsxHelper.YesNo(item.CollaborationInDataSoftware), label: 'Will Collaboration be Used in Data Software?' },
        { name: 'Mspplatform', label: 'MSP Platform' },
        { name: (item) => <LookupTextLookupItemIdArray lookupId={20} valueArray={item.RequiredLanguageCode} />, label: 'Required Language(s) Reporting' },
        { name: (item) => <LookupText lookupId={21} value={item.DataCaptureMethodCode} />, label: 'Data Capture Method' },
        { name: 'OtherDataCaptureMethod', label: 'Other Data Capture Method Description' },
      ],
    },
    ...ServiceListItem.commonEndTabs,
  ];
}
